import React from 'react';
import UserBooks from './UserBooks';

const Lists = ({
  user,
  userData,
  fetchBooks,
  fetchUserData,
  books,
  showNotification,
  updateCurrentlyReading,
}) => {
  return (
    <main>
      <UserBooks
        user={user}
        userData={userData}
        showNotification={showNotification}
        books={books}
        fetchBooks={fetchBooks}
        fetchUserData={fetchUserData}
        updateCurrentlyReading={updateCurrentlyReading}
      />
    </main>
  );
};

export default Lists;
